import styled from "styled-components";

export const StatusPreRolloverWrapper = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding-inline-start: ${({ theme }) => theme.space[2]};
  padding-inline-end: ${({ theme }) => theme.space[2]};
`;

export const CountdownTimerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
  margin-top: ${({ theme }) => theme.space[5]};
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[3]}`};
  border: ${({ theme }) => theme.borders[2]};
  border-radius: ${({ theme }) => theme.radii[3]};
  background-color: ${({ theme }) => theme.colors.white4};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[3]};
  width: 100%;
  padding: ${({ theme }) => theme.space[3]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 40%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    width: 34%;
  }
`;

export const StatsTableSection = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.space[4]};
  margin-top: ${({ theme }) => theme.space[5]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const StatsTableItem = styled.div<{ $mobileOrder: number }>`
  order: ${({ $mobileOrder }) => $mobileOrder};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    order: unset;
  }
`;
